
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexcDytY9ua4ON_oBoxXyTlQCqPkyV4F_YEXtcQSOaahYIMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/login/index.vue?macro=true";
import { default as who_45are_45youSR4GWmLOQ_o4sMNMRTXg1rzeYycCL2MvQT3HkHTzC1QMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/who-are-you.vue?macro=true";
import { default as indexj87YSXH_Em_bQ8RImdowVrc0HaxZsA2gL1Wt4iabsvoMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/signin/index.vue?macro=true";
import { default as insightspDr2PcKE3PdY3XtOilLjS38sVsmSrLSb6ESP1ywplOgMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/signin/insights.vue?macro=true";
import { default as unknown_45accountQ_ol_q0q5NGuo_C8gQmil5pxnHGNT2C62vXro4SWd7gMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/signin/unknown-account.vue?macro=true";
import { default as _91token_93xwWiVlsLm_PsF7YLq1NwJFu14Dyc5YpOxYlnM2htDaMMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/password-renewal/[token].vue?macro=true";
import { default as sentry_45error_45playgroundjixHuw_Oo1tpRWHZa0y2STVSB25w1vBb87W9NK68eewMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-monitoring/nuxt-sentry-v2-module/src/runtime/pages/sentry-error-playground.vue?macro=true";
import { default as ssr_45error9xwVIq7iH4Gyxu3umQmk22dmj8e1lBbRnt1Dpcn6u7wMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-monitoring/nuxt-sentry-v2-module/src/runtime/pages/sentry-error-playground/ssr-error.vue?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/login/index.vue")
  },
  {
    name: "who-are-you",
    path: "/who-are-you",
    meta: who_45are_45youSR4GWmLOQ_o4sMNMRTXg1rzeYycCL2MvQT3HkHTzC1QMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/who-are-you.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: indexj87YSXH_Em_bQ8RImdowVrc0HaxZsA2gL1Wt4iabsvoMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/signin/index.vue")
  },
  {
    name: "signin-insights",
    path: "/signin/insights",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/signin/insights.vue")
  },
  {
    name: "signin-unknown-account",
    path: "/signin/unknown-account",
    meta: unknown_45accountQ_ol_q0q5NGuo_C8gQmil5pxnHGNT2C62vXro4SWd7gMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/signin/unknown-account.vue")
  },
  {
    name: "password-renewal-token",
    path: "/password-renewal/:token()",
    meta: { ...(_91token_93xwWiVlsLm_PsF7YLq1NwJFu14Dyc5YpOxYlnM2htDaMMeta || {}), ...{"middleware":"password-renewal-token"} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/registration/registration-front/app/pages/password-renewal/[token].vue")
  },
  {
    name: "sentry-error-playground",
    path: "/registration/sentry-error-playground",
    meta: { ...(sentry_45error_45playgroundjixHuw_Oo1tpRWHZa0y2STVSB25w1vBb87W9NK68eewMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-monitoring/nuxt-sentry-v2-module/src/runtime/pages/sentry-error-playground.vue")
  },
  {
    name: "sentry-error-playground-ssr-error",
    path: "/registration/sentry-error-playground/ssr-error",
    meta: { ...(ssr_45error9xwVIq7iH4Gyxu3umQmk22dmj8e1lBbRnt1Dpcn6u7wMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-monitoring/nuxt-sentry-v2-module/src/runtime/pages/sentry-error-playground/ssr-error.vue")
  }
]